import moment from 'moment';

export const validateWorkingTime = ({ startTime, endTime } = {}) => {
  //startTime should be before endTime
  if (!startTime || !endTime) return true;

  return moment(startTime).isBefore(endTime);
};

export const formatCurrency = (currency) => {
  if (!currency) return '';
  return currency.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
